import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'app/shared/confirm-dialog/confirm-dialog.component';

@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) {
  }

  askConfirmation({ message = 'SHARED.LABELS.ARE_YOU_SURE', okButton = 'SHARED.BUTTONS.YES', cancelButton = 'SHARED.BUTTONS.NO', props = {} }): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        minWidth: 400,
        maxWidth: 800,
        data: new ConfirmDialogModel({ message, ok: okButton, cancel: cancelButton, props }),
      });

      dialogRef.afterClosed().subscribe(resolve);
    });
  }
}
